(function utilityNavigation($, Drupal, once) {
  Drupal.behaviors.rutherfordUtilityNavigation = {
    attach(context) {
      $(once(
        'rutherford-utility-navigation-drilldown',
        '.utility-navigation[data-drilldown]',
        context
      ))
        .each(function eachNav() {
          const _drilldown = new Foundation.Drilldown($(this));

          $(window).on('changed.zf.mediaquery', () => {
            $('.utility-navigation')
              .closest('.is-drilldown')
              .attr('style', '');
          });
        });
      $(once(
        'rutherford-utility-navigation-dropdown',
        '.utility-navigation[data-dropdown-menu]',
        context
      ))
        .each(function eachNav() {
          const _dropdown = new Foundation.DropdownMenu($(this));
        });
    },
  };
})(jQuery, Drupal, once);
